import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class UpdateAppRequest extends BaseUpdateRequest {   			
	minimumVersion = '';			
}